var accordion = {};

function toggle($header) {
	let $accordion = $header.parents('.accordion');
	if (!$accordion.hasClass('is-busy')) {
		$accordion.addClass('is-busy');
		if (!$header.hasClass('is-active')) {
			if ($accordion.find('.accordion-header.is-active').length != '') {
				close($accordion.find('.accordion-header.is-active'));
			}
			open($header, function() {
				$accordion.removeClass('is-busy');
			});
		} else {
			close($header, function() {
				$accordion.removeClass('is-busy');
			});
		}
	}
}

function open($header, cb) {
	let $content = $header.next('.accordion-content'),
			height = $content.find('.accordion-body').outerHeight(true);
	$header.addClass('is-active');
	$content.addClass('is-active');
	$content.css({'height' : height});
	setTimeout(function() {
		if (typeof cb == "function") {
			cb();
		}
	}, 550);
}

function close($header, cb) {
	let $content = $header.next('.accordion-content'),
			height = 0;
	$header.removeClass('is-active');
	$content.removeClass('is-active');
	$content.css({'height' : height});
	setTimeout(function() {
		if (typeof cb == "function") {
			cb();
		}
	}, 550);
}

function resize($header) {
	var $content = $header.next('.accordion-content'),
			height = $content.find('.accordion-body').outerHeight(true);
	$content.css({'height' : height});
}

accordion.init = function() {
	$('.accordion .accordion-header').click(function(e) {
		e.preventDefault();
		var $header = $(this);
		toggle($header);
	});
}

accordion.resize = function() {
	$('.accordion .accordion-header.is-active').each(function() {
		var $header = $(this);
		resize($header);
	});
}

export { accordion };
